import api from '../token';

export const DeleteProduto = async (payload) => {
  try {
    const response = await api.post('/destroy',payload);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

